// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminAiProductContent = (client) => ({
    /**
     * `POST /admin/ai-product-content/staging/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAiProductContentStagingApprove
     * @source packages/medusa-plugin-ai-product-content/src/api/admin/ai-product-content/staging/[id]/approve/route.ts
     */
    approveStaging: (id, body, query, headers) => client.fetch(buildPath("/admin/ai-product-content/staging/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/ai-product-content/applications/:id/generate`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAiProductContentApplicationGenerate
     * @source packages/medusa-plugin-ai-product-content/src/api/admin/ai-product-content/applications/[id]/generate/route.ts
     */
    generateApplications: (id, body, query, headers) => client.fetch(buildPath("/admin/ai-product-content/applications/:id/generate", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/ai-product-content/staging/:id/candidates`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAiProductContentStagingCandidates
     * @source packages/medusa-plugin-ai-product-content/src/api/admin/ai-product-content/staging/[id]/candidates/route.ts
     */
    listStagingCandidates: (id, query, headers) => client.fetch(buildPath("/admin/ai-product-content/staging/:id/candidates", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/ai-product-content/staging/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAiProductContentStagingReject
     * @source packages/medusa-plugin-ai-product-content/src/api/admin/ai-product-content/staging/[id]/reject/route.ts
     */
    rejectStaging: (id, body, query, headers) => client.fetch(buildPath("/admin/ai-product-content/staging/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/ai-product-content/jobs/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAiProductContentGetJob
     * @source packages/medusa-plugin-ai-product-content/src/api/admin/ai-product-content/jobs/[id]/route.ts
     */
    retrieveJob: (id, query, headers) => client.fetch(buildPath("/admin/ai-product-content/jobs/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=ai-product-content.js.map